// fileUtils.ts
export const downloadFile = (fileUrl: string, fileName: string) => {
  try {
    if (!fileUrl || fileUrl.trim() === "") {
      console.error("Empty file URL provided");
      return;
    }

    const cleanUrl = fileUrl.trim();
    new URL(cleanUrl); // Validate URL

    const link = document.createElement("a");
    link.href = cleanUrl;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    const urlParts = cleanUrl.split("/");
    const originalFileName = urlParts[urlParts.length - 1] || "contract";
    const extension = originalFileName.split(".").pop()?.toLowerCase() || "pdf";
    const sanitizedName = fileName.replace(/[^\w\s\u0400-\u04FF-]/g, "");

    link.download = `${sanitizedName}.${extension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
    try {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } catch (fallbackError) {
      console.error("Fallback also failed:", fallbackError);
    }
  }
};
